var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.588c-.318 0-.53-.211-.53-.53 0-.952.424-1.905 1.271-2.54.424-.318.53-.741.424-1.27-.106-.424-.424-.848-.953-.954-.424-.106-.741 0-1.059.212-.318.212-.424.635-.424.953 0 .318-.211.53-.529.53-.318 0-.53-.212-.53-.53 0-.741.318-1.377.848-1.8.53-.424 1.27-.635 1.906-.424.847.212 1.588.847 1.8 1.8.211.847-.106 1.694-.848 2.33-.529.423-.952 1.059-.952 1.694.106.318-.106.53-.424.53zm0 3.177c-.106 0-.318-.106-.423-.212-.106-.106-.106-.211-.106-.317 0-.106 0-.318.106-.424a.512.512 0 01.74 0c.107.106.213.212.213.424 0 .106-.106.317-.212.317 0 .106-.212.212-.318.212z",
    fill: "var(--color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21c-4.976 0-9-4.023-9-9 0-4.976 4.024-9 9-9 4.977 0 9 4.024 9 9 0 4.977-4.023 9-9 9zm0-16.941c-4.341 0-7.941 3.6-7.941 7.941 0 4.341 3.6 7.941 7.941 7.941 4.341 0 7.941-3.6 7.941-7.941 0-4.341-3.6-7.941-7.941-7.941z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.c9ddaeb6c2063041fa48d235c3d1718b.svg";
export { ForwardRef as ReactComponent };